<div class="hitbox">
  <ui-icon icon={getIcon}></ui-icon>
</div>
